import(/* webpackMode: "eager" */ "/vercel/path0/src/app/order/page.tsx");
